import React from 'react';

export type NotificationChannel = {
  id: string;
  name: string;
  label: string;
  value: string;
  enabled: boolean;
  icon: string;
  description: string;
  gradient?: string;
};

type NotificationChannelCardProps = {
  channel: NotificationChannel;
  onToggle: (id: string) => void;
  onValueChange: (id: string, value: string) => void;
};

const NotificationChannelCard: React.FC<NotificationChannelCardProps> = ({ channel, onToggle, onValueChange }) => {
  const inputId = `notification-channel-${channel.id}`;
  const gradient = channel.gradient ?? 'linear-gradient(to bottom, #186FE0, #009EF7)';

  return (
    <div className='animated zoomIn col-12 col-md-6 col-xxl-4 justify-self-end'>
      <div className={`card my-3 h-min-300px animated ${window.innerWidth > 576 ? 'hover-grow' : ''} w-100`}>
        <div className='card-body p-0'>
          <div
            className='px-9 pt-7 card-rounded h-275px w-100'
            style={{
              backgroundImage: gradient,
            }}
          >
            <div className='d-flex flex-stack'>
              <div className='d-flex align-items-center gap-3 text-white'>
                <i className={`bi ${channel.icon} fs-2x text-white`} />
                <span className='fw-bold fs-2x'>{channel.name}</span>
              </div>
              <span className={`badge badge-lg ${channel.enabled ? 'badge-light-success' : 'badge-light-danger'}`}>
                {channel.enabled ? 'ON' : 'OFF'}
              </span>
            </div>
            <div className='d-flex text-center flex-column text-white pt-8'>
              <span className='fw-semibold fs-7'>Notification Channel</span>
              <span className='fw-bold fs-6 text-secondary pt-1 border-0 background-transparent'>{channel.description}</span>
            </div>
          </div>
          <div
            className='shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-body'
            style={{ marginTop: '-50px' }}
          >
            <div className='d-flex align-items-center mb-6'>
              <div className='d-flex align-items-center flex-wrap w-100'>
                <div className='mb-1 pe-3 flex-grow-1'>
                  <label htmlFor={inputId} className='fs-5 text-gray-800 text-hover-primary fw-bold'>
                    {channel.label}
                  </label>
                  <div className='text-gray-400 fw-semibold fs-7'>Editable</div>
                </div>
                <div className='d-flex align-items-center'>
                  <input
                    id={inputId}
                    type='text'
                    className='form-control form-control-sm form-control-solid'
                    value={channel.value}
                    onChange={(event) => onValueChange(channel.id, event.target.value)}
                    style={{ minWidth: '150px' }}
                  />
                </div>
              </div>
            </div>
            <div className='d-flex align-items-center'>
              <button
                type='button'
                className={`btn w-100 ${channel.enabled ? 'btn-danger' : 'btn-success'}`}
                onClick={() => onToggle(channel.id)}
              >
                <span className='text-white'>{channel.enabled ? 'Turn Off' : 'Turn On'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationChannelCard;
